import {
  SITE_AUTHENTICATION_PATHS,
  SITE_AUTHENTICATION_ROUTES,
} from "src/consts/Routes/SiteAuthentication";
import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageSubTitle from "../../../Displays/PageSubTitle";
import PageTitle from "src/components/Displays/PageTitle";
import VerticalLinearProgress from "../../VerticalLinearProgressBar";

export const progressBarCalculator = (pathname: string) => {
  switch (pathname) {
    case SITE_AUTHENTICATION_PATHS.SUCCESS:
      return 55;
    case SITE_AUTHENTICATION_PATHS.FAILED:
      return 55;
    default:
      return 0;
  }
};

const SiteAuthenticationProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SITE_AUTHENTICATION_ROUTES.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - progressBarCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Hardware Zugriff"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SiteAuthenticationProgressBar;
